
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';


export const ServiceabilityValuesComponent = ({
  selectedServiceabilityValues,
  onInnerBasicFormChange,
  selectedServiceabilitys,
  onFormServiceabilityItemChange,
  shippingType,
  categories,
  pinCodes
}: any) => {
  // const selectedServiceabilitys.PINCode: any = cardData.length > 0 ? JSON.parse(cardData) : []
  return(
  <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
      label="PIN CODE" 
      labelField="Code"
      list={pinCodes}
      onValueChange={( newValue: any) => {
        const pinCodeData: any = newValue.map((option: any) => option?.value || '')
        onInnerBasicFormChange(
          pinCodeData,
          'PINCode'
        )
      }}
      type="multiselect"
      valueField="Code"
      value={selectedServiceabilitys?.PINCode}
  />
  </div>
    }
    expandedPanel="servicability"
    headerTitle="Servicability Check"
  />
    {_.map(
      selectedServiceabilityValues,
      (selectedServiceabilityValue: any, index: any) => (
        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4">
           <InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
  onFormServiceabilityItemChange({
   value: event,
   field: 'IsActive',
   idx: index

})
}}
type="checkbox"
value={selectedServiceabilityValue?.IsActive}
/>

<InputContainer
   label="Name"
   labelField="Name"
   onValueChange={(event: any, newValue: any) => {
     onFormServiceabilityItemChange({
       value: event.target.value,
       field: 'Name',
       idx: index
     });
   }}
   type="text"
   value={selectedServiceabilityValue?.Name}

/>


<InputContainer
label="Shipping Type"
labelField="Text"
list={shippingType}
onValueChange={(event: any, newValue: any) => {
onFormServiceabilityItemChange({
 value: event.target.value,
 field: 'ShippingTypeId',
 idx: index
});
}}
optionName='Choose ShippingType'
type="select"
value={selectedServiceabilityValue?.ShippingTypeId}
valueField="Value"
/>

<InputContainer

label="Delivery Hub Enabled"
name="IsActive"
onValueChange={(event: any) => {
  onFormServiceabilityItemChange({
   value: event,
   field: 'IsDeliveryHubEnabled',
   idx: index
})
}}
type="checkbox"
value={selectedServiceabilityValue?.IsDeliveryHubEnabled}
/>

<InputContainer
   label="Radius Unit"
   labelField="unit"
   onValueChange={(event: any, newValue: any) => {
     onFormServiceabilityItemChange({
       value: event.target.value,
       field: 'unit',
       idx: index
     });
   }}
   type="text"
   value={selectedServiceabilityValue?.unit}

/>

<InputContainer
   label="Radius Value"
   labelField="value"
   onValueChange={(event: any, newValue: any) => {
     onFormServiceabilityItemChange({
       value: event.target.value,
       field: 'value',
       idx: index
     });
   }}
   type="text"
   value={selectedServiceabilityValue?.value}

/>

<InputContainer
   label="Category"
   labelField="CategoryName"
   list={categories}
   onValueChange={(event: any, newValue: any) => {
     onFormServiceabilityItemChange({
       value: event.target.value,
       field: 'EntityId',
       idx: index
     });
   }}
   optionName='Choose Category'
   type="select"
   value={selectedServiceabilityValue?.EntityId}
   valueField="Id"
/>

               </div>
      ),
    )}
  </>
)}
export default ServiceabilityValuesComponent;
